import { RESET_STATE, SET } from "@/stores/CommumActionTypes";

const actions = {
	[SET]: ({ commit }, signal) =>
	{
		commit(SET, signal);
	},
	[RESET_STATE]: ({ commit }) =>
	{
		commit(RESET_STATE);
	},
};

export default { actions };